import { Component, Prop } from "@stencil/core";
import { getIconRegistry } from "../registry";
import { IconThemeType } from "../types";

@Component({
    tag: "ux-icon-registry",
    shadow: false
})
export class IconRegistry {
    /** Configure public path where asset files are served from */
    @Prop() readonly assetsPath: string | undefined;
    /** Configure the icon theme explicitly */
    @Prop() readonly theme: IconThemeType | undefined;

    componentWillLoad() {
        if (typeof this.assetsPath === "string") {
            getIconRegistry().setAssetsPath(this.assetsPath);
        }
        // @ts-expect-error Check for typing
        if (["web", "responsive"].includes(this.theme)) {
            // @ts-expect-error Check for typing
            getIconRegistry().setTheme(this.theme);
        }
    }
}
